//@ts-nocheck
/* eslint-disable */
import { axiosInstance } from './requestMethods';
import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getAnonymousToken as fetchAnonymousToken } from '../../APIs/authApi';
import useAuth from '../../context/auth/useAuth';
import { useRef } from 'react';
import { anonymousTokenApiConfig, refreshApiConfig } from '@/constants/ApiUrls';
import { toast } from 'sonner';

type AxiosInstanceMethod = <R>() => Promise<R>;
type Config = InternalAxiosRequestConfig & {
    handleLocal: boolean;
};

let isRefreshingTokens = false;
/* list of requests that are waiting for getting refresh token */
let toBeSentRequestsQueue = [];

/* list of requests that are waiting for getting anonymous token when app loads for the first time */
let isGettingAnonymousToken = false;
let toBeContinuedRequests = [];

const resendRequest = <D, R>(
    originalRequestConfig: Config<D>,
    resolve: AxiosInstanceMethod<R>
): void | Promise<R> => {
    originalRequestConfig.headers.Authorization = localStorage.getItem('token');
    if (resolve) {
        resolve(axiosInstance({ ...originalRequestConfig }));
    } else {
        return axiosInstance({ ...originalRequestConfig });
    }
};

const continueRequest = (originalRequestConfig, resolve) => {
    originalRequestConfig.headers.Authorization = localStorage.getItem('token');
    resolve(originalRequestConfig);
};

const resendQueuedRequests = () => {
    toBeSentRequestsQueue.forEach((queuedRequest) => {
        queuedRequest();
    });

    toBeSentRequestsQueue = [];
};

const continueToBeContinuedRequests = () => {
    toBeContinuedRequests.forEach((toBeContinuedRequest) => {
        toBeContinuedRequest();
    });

    toBeContinuedRequests = [];
};

const getAnonymousToken = async ({ persistTokenCallback }) => {
    try {
        isGettingAnonymousToken = true;
        const anonymousTokenData = await fetchAnonymousToken();
        persistTokenCallback({
            token: anonymousTokenData?.data?.access_token,
            refreshToken: anonymousTokenData?.data?.refresh_token
        });
        isGettingAnonymousToken = false;
        continueToBeContinuedRequests();
    } catch (error) {
        /* do error handling stuff here */
        console.log('error is: ', error);
        return error;
    } finally {
        isGettingAnonymousToken = false;
    }
};

const getRefreshToken = async (
    persistTokenCallback: ({ token, refreshToken }: { token: string; refreshToken: string }) => void
) => {
    try {
        isRefreshingTokens = true;
        const previousRefreshToken = localStorage.getItem('refreshToken');

        const {
            data: {
                data: { access_token: token, refresh_token: refreshToken }
            }
        } = await axios.get(refreshApiConfig.url, {
            baseURL: refreshApiConfig.baseUrl,
            headers: { 'x-refresh-token': previousRefreshToken }
        });
        persistTokenCallback({ token, refreshToken });
        /* idle the isRefreshingTokens flag */
        isRefreshingTokens = false;
        resendQueuedRequests();
    } catch (error) {
        /* do error handling stuff here */
        console.log('error is: ', error);
        // note: we considered that getAnonymousToken requestMethods will always get to success
        try {
            await getAnonymousToken({ persistTokenCallback });
            /* idle the isRefreshingTokens flag */
        } catch (err) {
            /* do error handling stuff */
            console.log('error is: ', error);
        } finally {
            isRefreshingTokens = false;
            resendQueuedRequests();
        }
        return Promise.error(error);
    }
};

const handle401Error = async <T, R, D>({
    error,
    persistTokenCallback
}: {
    error: AxiosError<T, D>;
    persistTokenCallback: ({
        token,
        refreshToken
    }: {
        token: string;
        refreshToken: string;
    }) => void;
}) => {
    const originalRequestConfig: Config<D> = error.config;
    // todo: handle login and signup requests, if they got to 401 for example..., if they were not because of token expiration, no need to send refresh token requestMethods
    // todo: in future, we might get the expiration time of tokens and only send refresh token if it was expired, not always
    if (!originalRequestConfig.isRetryRequest) {
        originalRequestConfig.isRetryRequest = true;
        if (!isRefreshingTokens) {
            try {
                await getRefreshToken(persistTokenCallback);
                return resendRequest<D, R>(originalRequestConfig);
            } catch (err) {
                /* do error handling stuff here */
                console.log('error is: ', error);
                /* if the process of getting refresh token yielded to 401 error, then anonymous token must be gotten */
                // resend requestMethods with new anonymous tokens
                if (originalRequestConfig.isPublic) {
                    return resendRequest<D, R>(originalRequestConfig);
                } else {
                    // todo: here it is possible to do a custom action, maybe navigating user to the login or home page, e.g getting callback from each requestMethods
                    return Promise.reject(error);
                }
            }
        } else {
            return new Promise<Promise<R>>((resolve) => {
                toBeSentRequestsQueue.push(() =>
                    resendRequest<D, R>(originalRequestConfig, resolve)
                );
            });
        }
    } else {
        // todo: here it is possible to do a custom action, maybe navigating user to the login or home page, e.g getting callback from each requestMethods
        return Promise.reject(error);
    }
};

const handle403Error = async <T, R, D>({
    error,
    persistTokenCallback
}: {
    error: AxiosError<T, D>;
    persistTokenCallback: ({
        token,
        refreshToken
    }: {
        token: string;
        refreshToken: string;
    }) => void;
}) => {
    const originalRequestConfig: Config<D> = error.config;
    // todo: handle login and signup requests, if they got to 401 for example..., if they were not because of token expiration, no need to send refresh token requestMethods
    if (!originalRequestConfig.isRetryRequest) {
        originalRequestConfig.isRetryRequest = true;
        if (!isRefreshingTokens) {
            try {
                await getRefreshToken(persistTokenCallback);
                return resendRequest<D, R>(originalRequestConfig);
            } catch (err) {
                /* do error handling stuff here */
                console.log('error is: ', error);

                /* if the process of getting refresh token yielded to 401 error, then anonymous token must be gotten */
                // resend requests with new anonymous tokens
                if (originalRequestConfig.isPublic) {
                    return resendRequest<D, R>(originalRequestConfig);
                } else {
                    // todo: here it is possible to do a custom action, maybe navigating user to the login or home page, e.g getting callback from each requestMethods
                    toast.error('برای این کار باید اول وارد حساب کاربری ت بشی!');
                    return Promise.reject(error);
                }
            }
        } else {
            return new Promise<Promise<R>>((resolve) => {
                toBeSentRequestsQueue.push(() =>
                    resendRequest<D, R>(originalRequestConfig, resolve)
                );
            });
        }
    } else {
        // todo: here it is possible to do a custom action, maybe navigating user to the login or home page, e.g getting callback from each requestMethods
        toast.error('برای این کار باید اول وارد حساب کاربری ت بشی!');
        return Promise.reject(error);
    }
};

const useRequest = () => {
    const { persistTokens } = useAuth();

    const axiosInterceptorIsSet = useRef<boolean>(false);

    if (!axiosInterceptorIsSet.current) {
        axiosInstance.interceptors.request.use(async (config) => {
            const token = localStorage.getItem('token');

            if (!token) {
                if (!isGettingAnonymousToken) {
                    getAnonymousToken({ persistTokenCallback: persistTokens });
                }
                if (config.url !== anonymousTokenApiConfig.url) {
                    return new Promise<Promise<Config>>((resolve) => {
                        toBeContinuedRequests.push(() => continueRequest(config, resolve));
                    });
                }
            }

            return config;
        });

        axiosInstance.interceptors.response.use(
            (response: AxiosResponse) => {
                // This function triggers for 2xx response codes
                response.config?.onSuccessCallback?.(response);

                return response;
            },
            async <T, D>(error: AxiosError<T, D>) => {
                let message: string = '';

                if (
                    error.config.handleLocal?.includes(error.message) ||
                    error.config.handleLocal?.includes(error.response.status)
                )
                    return Promise.reject(error);

                if (error.message === 'Network Error') {
                    return toast.error('خطایی رخ دادهههه!، اتصال اینترنت خود را بررسی کنید');
                }

                // This function triggers for non-2xx response codes
                if (error.response) {
                    // The requestMethods was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    switch (error.response.status) {
                        case 400:
                            {
                                // todo: here we must have a unified error template, that is handshaked with backend
                                message =
                                    error?.response?.data?.message ||
                                    error?.response?.data?.data?.message ||
                                    error?.message ||
                                    'اینجوری نمی‌شه! یه جای کار می‌لنگه...';
                                break;
                            }
                            break;
                        case 401:
                            return handle401Error<T, D>({
                                error,
                                persistTokenCallback: persistTokens
                            });
                        case 403:
                            return handle403Error<T, D>({
                                error,
                                persistTokenCallback: persistTokens
                            });
                        case 404:
                            message = 'هیچی پیدا نکردم. مطمئنی درست گفتی؟';
                            break;
                        case 500:
                            message = 'یه مشکلی سمت سرور پیش اومده. بیا بعدا دوباره تلاش کنیم.';
                            break;
                        default:
                            message = `یه خطایی اتفاق افتاده با این کد: ${error.response.status}`;
                    }
                    if (error.response.status === 400) toast.error(message);
                    else console.error(message, error.response.data);
                } else if (error.request) {
                    // The requestMethods was made but no response was received
                    console.error('سعی کردم جواب بگیرم، ولی کسی جوابمو نداد.');
                } else {
                    // Something happened in setting up the requestMethods that triggered an Error
                    console.error('یه اتفاقی افتاده. نمی‌دونم چی شده!');
                }

                if (message) {
                    console.error(message);
                }

                // Propagate the error for further handling if necessary
                return Promise.reject(error);
            }
        );

        axiosInterceptorIsSet.current = true;
    }
};

export default useRequest;
